/*
 * Request money completed screen
 *
 * @param {Boolean} isSuccess Request money is success or fail
 *
 * @return {Element}
 */
<template>
  <div class="register-container">
    <h2 class="text-center m-b-md">
      <span v-if="isSuccess">出金依頼が完了しました。</span>
      <span v-else>出金依頼が失敗しました。</span>
    </h2>
    <div class="announce-container text-center">
      <template v-if="isSuccess">
        <span>出金依頼ありがとうございました。</span>
        <br>
        <br><span>7営業日以内に</span>
        <br>
        <span>ご指定の方法でお支払いさせていただきます。</span>
        <br>
        <br>
        <span>お手続きまで今しばらくお待ちください。</span>
      </template>
      <template v-else>
        <span>出金依頼が失敗しました。</span>
        <br>
        <br><span>お時間を置いてから</span>
        <br>
        <span>
          再度
          <a @click="$emit('refreshScreen')">こちら</a>
          から依頼をお願い致します。
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isSuccess: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/revenue/ReqMoneyComplete.vue